import { useLazyQuery } from '@apollo/client';

import { queryParams } from 'app/shared/utils/queries';
import { SharedGetDataParameters } from 'app/shared/typings/generics';

import { GET_ARTIST_FOLLOWING } from './queries';

interface GetArtistFollowingVariables extends SharedGetDataParameters {
  artistId?: number;
  userId?: number;
}

interface GetArtistFollowingData {
  artistFollowing: {
    id: number;
    following: boolean;
  };
}

export const GetArtistFollowingLazy = (
  params: GetArtistFollowingVariables = {}
) => {
  return useLazyQuery<GetArtistFollowingData>(
    GET_ARTIST_FOLLOWING,
    queryParams(params)
  );
};
